var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1128({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:square;stroke-linejoin:round;stroke-width:0.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 7.71,
    r: 4.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.43,8.73a4.91,4.91,0,0,0,.12-1,4.91,4.91,0,0,0-.12-1L15,4.81l-3.15.49a4.71,4.71,0,0,0-1.44-1.44L10.9.71,9,3.28a4.91,4.91,0,0,0-1-.12,4.91,4.91,0,0,0-1,.12L5.1.71l.49,3.15A4.71,4.71,0,0,0,4.15,5.3L1,4.81,3.57,6.69a4.91,4.91,0,0,0-.12,1,4.91,4.91,0,0,0,.12,1L1,10.61l3.15-.49a4.6,4.6,0,0,0,1.44,1.44L5.1,14.71,7,12.14a4.91,4.91,0,0,0,1,.12,4.91,4.91,0,0,0,1-.12l1.88,2.57-.49-3.15a4.6,4.6,0,0,0,1.44-1.44l3.15.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1128);
export default __webpack_public_path__ + "static/media/Symbolpack_1_128.614e8c3aa66410554b62da40d965cdf3.svg";
export { ForwardRef as ReactComponent };